import React from 'react';
import {withExplicitProps} from 'polyphony/hoc';

const PostWrapper = withExplicitProps(({ post, style, children }) => {
    return <>
      <article id={post.dom.id}
               className={"singular-post " + post.dom.class}
               style={style} children={children} />
    </>;
}, ['post', 'style', 'children']);

PostWrapper.displayName = 'PostWrapper';

export default PostWrapper;

